import { render, staticRenderFns } from "./PropertiesPaymentForm.vue?vue&type=template&id=160173f8&scoped=true"
import script from "./PropertiesPaymentForm.vue?vue&type=script&lang=js"
export * from "./PropertiesPaymentForm.vue?vue&type=script&lang=js"
import style0 from "./PropertiesPaymentForm.vue?vue&type=style&index=0&id=160173f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160173f8",
  null
  
)

export default component.exports